import { ApiResult } from "~/models/ApiResult";
import { type AxiosResponse } from "axios";
import { BaseService } from "./BaseService";
import {
  UserLoginRequest,
  UserLoginResponse,
  UserRegisterRequest,
  VerifyPhoneRequest,
  UserRegisterResponse,
  ForgotPasswordChangeWithFlagCodeRequest,
  ProfileChangePasswordRequest,
  UserProfileInformationsResponse,
  GetAllPastPaymentsRequest,
  GetAllPastPaymentsResponse,
  UserProfileInformationUpdateRequest,
  UserSettingsUpdateRequest,
  RepeatCodeForVerifyPhoneRequest
} from "~/models/UserModels";

export class UserService extends BaseService {
  constructor() {
    super("User");
  }

  Login(body: UserLoginRequest): Promise<AxiosResponse<ApiResult<Array<UserLoginResponse>>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/Login`, body)
  }
  LoginWithFireBase(body: { idToken: string }): Promise<AxiosResponse<ApiResult<Array<UserLoginResponse>>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/LoginWithFireBase`, body)
  }

  Register(body: UserRegisterRequest): Promise<AxiosResponse<ApiResult<Array<UserRegisterResponse>>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/Register`, body)
  }
  Logout({ }): Promise<AxiosResponse<ApiResult<Array<any>>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/Logout`, {})
  }
  VerifyPhone(body: VerifyPhoneRequest): Promise<AxiosResponse<ApiResult<Array<any>>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/VerifyPhone`, body)
  }
  RepeatCodeForVerifyPhone(body: RepeatCodeForVerifyPhoneRequest): Promise<AxiosResponse<ApiResult<Array<any>>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/RepeatCodeForVerifyPhone`, body)
  }
  ForgotPassword(body: { phone: string }): Promise<AxiosResponse<ApiResult<Array<any>>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/ForgotPassword`, body)
  }
  ForgotPasswordVerifyPhone(body: { code: string, phone: string }): Promise<AxiosResponse<ApiResult<Array<any>>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/ForgotPasswordVerifyPhone`, body)
  }
  ForgotPasswordChangeWithFlagCode(body: ForgotPasswordChangeWithFlagCodeRequest): Promise<AxiosResponse<ApiResult<Array<any>>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/ForgotPasswordChangeWithFlagCode`, body)
  }
  ProfileChangePassword(body: ProfileChangePasswordRequest): Promise<AxiosResponse<ApiResult<Array<any>>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/ProfileChangePassword`, body)
  }
  Profile(): Promise<AxiosResponse<ApiResult<Array<UserProfileInformationsResponse>>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/Profile`)
  }
  Me(): Promise<AxiosResponse<ApiResult<Array<UserProfileInformationsResponse>>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/Me`)
  }
  UpdateProfile(body: UserProfileInformationUpdateRequest): Promise<AxiosResponse<ApiResult<Array<any>>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/UpdateProfile`, body)
  }
  RecaptchaV3Verify(body: { token: string }): Promise<AxiosResponse<ApiResult<Array<any>>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/RecaptchaV3Verify`, body)
  }
  GetAllPastPayments(query: GetAllPastPaymentsRequest): Promise<AxiosResponse<ApiResult<Array<GetAllPastPaymentsResponse>>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/GetAllPastPayments`, query)
  }
  GetUserSettings(): Promise<AxiosResponse<ApiResult<Array<any>>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/UserSettings`)
  }
  UpdateUserSettings(body: UserSettingsUpdateRequest): Promise<AxiosResponse<ApiResult<Array<any>>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/UserSettingsUpdate`, body)
  }
  DeleteAccount(): Promise<AxiosResponse<ApiResult<Array<any>>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/Delete`, {})
  }
}
